export default __webpack_public_path__ + "static/media/mode-option-multiple.78ce901b.png";